import { Component, OnInit, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../authentication.service';
import { SubscriptionService } from '../../services/subscription.service';
import { ModalService } from '../../services/modals.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { VacationService } from '../../services/vacation.service';
import { closeModal, closeModalWithoutRemovingBackdrop } from '../../shared/modal-functions';
import { customerServiceView, subscriptionViewSpanish, changeCollectionTypeView } from './subscription.static.data';

import digitalTermsJson from './../../../assets/digital-terms.json';
import { ConditionalExpr } from '@angular/compiler';

declare var tp: any;
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['../../app.component.css']
})

export class SubscriptionComponent implements OnInit, AfterViewInit, OnDestroy {
  // Static data
  customerServiceView: any;
  subscriptionView: any;
  changeCollectionTypeView: any;
  // Control view
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  // Authentication
  isLoggedin: boolean;
  isLoggedInSubscription: Subscription;

  private sessionStorage = window.sessionStorage;

  constructor(private router: Router, public zone: NgZone, public authenticationService: AuthenticationService, public subscriptionService: SubscriptionService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService, public vacationService: VacationService) {
    this.customerServiceView = customerServiceView;
    this.subscriptionView = subscriptionViewSpanish;
    this.changeCollectionTypeView = changeCollectionTypeView;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
  }

  ngOnInit() {
    this.router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });

    if (this.authenticationService.typeOfUser === 'Registered') {
      const theTermObject = Object.keys(digitalTermsJson);
      const userTerm = this.sessionStorage.getItem("TermId").split(",");

      for (let termId in userTerm) {
        if (theTermObject.includes(userTerm[termId])) {
          this.authenticationService.typeOfUser = 'Digital';
        }
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.constructSubscription();
    });

    //execute Piano MyAccount if typeOfUser === Digital
    if (this.authenticationService.typeOfUser === 'Digital') {
      tp.myaccount.show({
        displayMode: "inline",
        containerSelector: "#my-account",
      });
    }
  }

  ngAfterViewChecked(): void {
    if (this.isLoggedin) {
      document.dispatchEvent(new Event('gfrSubscriptionView'));
    }
  }

  ngOnDestroy(): void {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();
    }
  }

  /*
    * Check if user has been authenticated to render either anonymous or logged in view.
    * If user is authenticated and token is not expired, get subscriptions by Gigya User Id
  */
  constructSubscription() {
    this.isLoggedInSubscription = this.authenticationService.getIsAuthenticated().subscribe((IsAuthenticated) => {
      this.zone.run(() => {
        if (IsAuthenticated && !this.authenticationService.isTokenExpired()) {
          this.isLoggedin = IsAuthenticated;
          if (this.authenticationService.typeOfUser === 'Subscriber' && !this.subscriptionService.customerSubscriptions) {
            this.subscriptionService.getSubscriptionDataSynch(this.authenticationService.gigyaId);
          }
        }
        if (IsAuthenticated && this.authenticationService.isTokenExpired()) this.authenticationService.logoutUserExpiredSession();
      });
    });
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  searchTerm(termId) {
    const theTermObject = Object.keys(digitalTermsJson);

    for (let i = 0; i < theTermObject.length; i++) {
      if (theTermObject[i] === termId) {
        return true
      }
    }
    return false
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/subscription.component.ts